import { render } from "./inventoryList.vue?vue&type=template&id=39d12ec9&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"

import "./inventoryList.vue?vue&type=style&index=0&id=39d12ec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d12ec9"]])

export default __exports__